// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"55":"6c5c9d74","423":"dfc5779a"}[chunkId] + ".css";
};